import React, { useState, useEffect, useRef } from "react";
import Adminhomemenu from "../Menus/Adminhomemenu";

import jsPDF from "jspdf";
import { autoTable } from "jspdf-autotable";
import addGujaratiFont from "../fonts/NotoSansGujarati";

export default function CreateQuestionPaper() {
  const user = JSON.parse(localStorage.getItem("user"));

  //const formRef = useRef(null);
  const [paperMode, setPaperMode] = useState(null);
  const [showLangModal, setShowLangModal] = useState(true);
  const [language, setLanguage] = useState("");
  const [examlanguage, setexamlanguage] = useState(user?.LANGUAGE_ID);
  const [paperLimitExceeded, setPaperLimitExceeded] = useState(false);
  const [tradeId, setTradeid] = useState(user?.TRADE_ID);
  const tradeName = user?.TRADE_NAME;
  const [limit, setLimit] = useState(null);
  const [tradedata, settradeData] = useState({ data: [] });
  const [isGenerating, setIsGenerating] = useState(false);
  const [testName, settestName] = useState("");
  const [numofQue, setnumofQue] = useState(20);

  const [topics, setTopics] = useState([]);
  // const [showTopics, setShowTopics] = useState(false);

  const [activeTopic, setActiveTopic] = useState(null);
  const [topicQuestions, setTopicQuestions] = useState({});
  const [selectedQuestions, setSelectedQuestions] = useState([]);

  const [selectedTopics, setSelectedTopics] = useState([]);

  //const ITI_NAME = (user?.ITI_NAME || "").toUpperCase();
  //const uid = user?.UID;
  /* ================= SUBJECT LIST ================= */

  useEffect(() => {
    fetchSubjects();
    // console.log(formRef.current);
    // if (!formRef.current) return;

    // // duplicate script avoid
    // if (formRef.current.querySelector("script")) return;

    // const script = document.createElement("script");
    // script.src = "https://checkout.razorpay.com/v1/payment-button.js";
    // script.async = true;
    // script.setAttribute("data-payment_button_id", "pl_SFWilfl6UXeswQ");

    // formRef.current.appendChild(script);
    chk_paper_limit();
  }, []);
  const chk_paper_limit = () => {
    const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_GET_PAPER_LIMIT}`;

    fetch(path, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        UID: user.UID,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.res === "success") {
          setLimit(data.limit_remain);
        }
      })
      .catch((err) => {
        console.log("Limit API Error:", err);
      });
  };
  const openRazorpay = () => {
    const options = {
      key: `${process.env.REACT_APP_BUY_KEY_ID}`,
      amount: `${process.env.REACT_APP_TOKEN_PRS}`, // 10 Rs
      currency: "INR",
      name: "EasyITI",
      description: "Buy Tokens",

      handler: function (response) {
        //alert("✅ Payment Success 😄");
        handleBuyToken();
        //console.log("SUCCESS:", response);
      },

      modal: {
        ondismiss: function () {
          alert("❌ Payment Cancelled ");
        },
      },

      theme: {
        color: "#3399cc",
      },
    };
    const rzp = new window.Razorpay(options);
    // ✅ FAILURE LISTENER 🔥
    rzp.on("payment.failed", function (response) {
      alert("❌ Payment Failed 😢");
      console.log("FAILED:", response);
    });

    rzp.open();
  };

  const fetchSubjects = async () => {
    try {
      const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_LIST_OF_SUBJECT}`;

      const res = await fetch(path, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          TRADE_ID: tradeId,
          TRADE_NAME: tradeName,
        }),
      });

      const data = await res.json();
      settradeData(data);
    } catch (err) {
      console.error("Subject fetch error", err);
    }
  };

  useEffect(() => {
    if (tradedata.data.length > 0) {
      const firstTrade = tradedata.data[0].TRADE_ID;
      setTradeid(firstTrade);
      fetchTopics(firstTrade);
    }
  }, [tradedata]);

  const setData = (e) => {
    setTradeid(e);
    fetchTopics(e);
  };

  /* ================= LANGUAGE ================= */

  const handleContinue = () => {
    if (!language) return alert("Please select language");

    setexamlanguage(language === "EN" ? 1 : language === "GU" ? 2 : 3);
    setShowLangModal(false);
  };

  /* ================= TOPICS ================= */

  const fetchTopics = async (trade_id) => {
    try {
      const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_LIST_OF_TOPIC}`;

      const res = await fetch(path, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ TRADE_ID: trade_id }),
      });

      const json = await res.json();
      setTopics(json.data || []);
      setSelectedTopics([]);
      setTopicQuestions({});
      setActiveTopic(null);
    } catch (err) {
      console.error("Topic fetch error", err);
    }
  };

  /* ================= MANUAL QUESTIONS ================= */

  const fetchQuestionsByTopic = async (topicId) => {
    if (topicQuestions[topicId]) {
      setActiveTopic(activeTopic === topicId ? null : topicId);
      return;
    }

    const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_GET_QUESTION1}`;

    const res = await fetch(path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        TRADE_ID: tradeId,
        TOPIC_UID: topicId,
        NUM_OF_QUE: numofQue,
        LANGUAGE_ID: examlanguage,
      }),
    });

    const json = await res.json();

    setTopicQuestions((prev) => ({
      ...prev,
      [topicId]: json.data || [],
    }));

    setActiveTopic(topicId);
  };

  /* ================= QUESTION SELECT ================= */

  const handleQuestionSelect = (queId) => {
    setSelectedQuestions((prev) => {
      if (prev.includes(queId)) {
        return prev.filter((id) => id !== queId);
      }

      if (prev.length >= numofQue) {
        alert(`Only ${numofQue} questions allowed`);
        return prev;
      }

      return [...prev, queId];
    });
  };

  /* ================= RANDOM TOPIC SELECT ================= */

  const handleTopicToggle = (topicId) => {
    setSelectedTopics((prev) =>
      prev.includes(topicId)
        ? prev.filter((id) => id !== topicId)
        : [...prev, topicId],
    );
  };

  /* ================= PDF GENERATOR ================= */

  const generatePDF = (questions) => {
    setIsGenerating(true);
    chk_paper_limit();
    const doc = new jsPDF("portrait", "mm", "a4");
    addGujaratiFont(doc);

    const pageWidth = doc.internal.pageSize.getWidth();
    let y = 20;
    const ITI_NAME = (user?.ITI_NAME || "").toUpperCase();
    console.log(ITI_NAME);
    const itiName =
      ITI_NAME === ""
        ? "INDUSTRIAL TRAINING INSTITUTE"
        : `INDUSTRIAL TRAINING INSTITUTE ${ITI_NAME}`;

    const today = new Date().toLocaleDateString("en-GB");

    doc.rect(15, 10, pageWidth - 30, 20);

    doc.setFont("NotoGujarati", "bold");
    doc.setFontSize(16);
    doc.text(itiName, pageWidth / 2, 22, { align: "center" });

    y = 38;

    doc.setFontSize(14);
    doc.text("QUESTION PAPER", pageWidth / 2, y, { align: "center" });

    y += 10;

    doc.setFont("NotoGujarati", "normal");
    doc.setFontSize(11);

    doc.text(`Paper Title : ${testName || "-"}`, 15, y);
    doc.text(`Date :    `, pageWidth - 60, y);

    y += 8;
    doc.line(15, y, pageWidth - 15, y);
    y += 8;

    const bodyData = questions.map((q, index) => [
      `Q${index + 1}. ${q.QUESTION}

A) ${q.OPT1}
B) ${q.OPT2}
C) ${q.OPT3}
D) ${q.OPT4}
`,
    ]);

    autoTable(doc, {
      startY: y,
      body: bodyData,
      theme: "plain",
      styles: {
        font: "NotoGujarati",
        fontSize: 11,
        cellPadding: 4,
      },
    });
    setTimeout(() => {
      doc.save("QuestionPaper.pdf");
      setIsGenerating(false);
    }, 500);
    // doc.save("QuestionPaper.pdf");
    // setIsGenerating(false);
  };

  /* ====== buy token ==================*/

  const handleBuyToken = async () => {
    //localStorage.setItem("payment_in_progress", "yes");
    //window.location.href = "https://rzp.io/rzp/OE4wbUA";

    try {
      const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_BUY_PAPER_LIMIT}`;

      const res = await fetch(path, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          UID: user.UID,
        }),
      });

      const data = await res.json();

      if (data.res === "success") {
        setPaperLimitExceeded(false);
        alert(`Token Purchased ✅\nRemaining Limit : ${data.limit_remain}`);
        chk_paper_limit();
      } else {
        alert("Payment Failed");
      }
    } catch (err) {
      console.error(err);
      alert("Server Error");
    }
  };

  /* ================= RANDOM PAPER ================= */

  const submitRandomPaper = async () => {
    if (!selectedTopics.length) return alert("Please select topics");

    const path1 = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_CHECK_PAPER_LIMIT}`;
    const res1 = await fetch(path1, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ UID: user.UID }),
    });

    const data1 = await res1.json();
    console.log(data1.limit_remain);
    if (parseInt(data1.limit_remain) === 0) {
      setPaperLimitExceeded(true);
      return alert("Paper limit exceeded. Please buy token.");
    }

    const topicString = selectedTopics.join(",");

    const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_GET_QUESTIONS_BY_TOPIC_IDS}`;

    const res = await fetch(path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        topic_ids: topicString,
        question_count: numofQue,
        LANGUAGE_ID: examlanguage,
      }),
    });

    const data = await res.json();

    if (data.status === "success") {
      generatePDF(data.questions);
    } else {
      alert(data.message);
    }
  };

  /* ================= MANUAL PAPER ================= */

  const submitManualPaper = async () => {
    if (selectedQuestions.length !== numofQue)
      return alert(`Select ${numofQue} questions`);

    const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_CHECK_PAPER_LIMIT}`;
    const res = await fetch(path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ UID: user.UID }),
    });

    const data = await res.json();
    console.log(data.limit_remain);
    if (parseInt(data.limit_remain) === 0) {
      setPaperLimitExceeded(true);
      return alert("Paper limit exceeded. Please buy token.");
    }

    const allQuestions = Object.values(topicQuestions).flat();

    const selectedData = allQuestions.filter((q) =>
      selectedQuestions.includes(q.QUE_UID),
    );

    generatePDF(selectedData);
  };

  /* ================= UI ================= */

  return (
    <>
      <Adminhomemenu title="EasyITI" />
      {isGenerating && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(0,0,0,0.4)",
            backdropFilter: "blur(4px)",
            zIndex: 9999,
          }}
        >
          <div className="text-center bg-white p-4 rounded shadow">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>

            <div className="mt-3 fw-bold">Generating PDF...</div>
          </div>
        </div>
      )}
      {!paperMode && (
        <div
        className="container"
        style={{
          paddingTop: "90px",
          height: "auto",
        }}
      >
          <button
            className="btn btn-primary w-100 mb-3"
            onClick={() => setPaperMode("random")}
          >
            🎲 Random Paper
          </button>

          <button
            className="btn btn-success w-100"
            onClick={() => setPaperMode("manual")}
          >
            ✍ Manual Paper
          </button>
        </div>
      )}

      {paperMode && showLangModal && (
        <div className="modal d-block bg-dark bg-opacity-50">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content p-3" style={{ height: "230px" }}>
              <h5>Select Language</h5>
              <select onChange={(e) => setLanguage(e.target.value)}>
                <option value="">Select</option>
                <option value="EN">English</option>
                <option value="GU">Gujarati</option>
                <option value="HI">Hindi</option>
              </select>
              <br></br>
              <button onClick={handleContinue}>Continue</button>
            </div>
          </div>
        </div>
      )}

      {!showLangModal && (
        <div className="container mt-4" style={{ height: "auto" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <div
              style={{
                background: "#ffffff",
                borderRadius: "15px",
                padding: "20px",
                boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                width: "400px",
              }}
            >
              <h4
                style={{
                  marginBottom: "15px",
                  color: "#333",
                  fontWeight: "600",
                  textAlign: "center",
                }}
              >
                📄 Paper Limit
              </h4>

              {limit !== null ? (
                <div
                  style={{
                    background: limit === 0 ? "#ffe5e5" : "#e8f5e9",
                    padding: "12px",
                    borderRadius: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontSize: "15px", color: "#555" }}>
                    Remaining Limit
                  </span>

                  <span
                    style={{
                      background: limit === 0 ? "#ff4d4f" : "#28a745",
                      color: "white",
                      padding: "5px 12px",
                      borderRadius: "20px",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    {limit}
                  </span>
                </div>
              ) : (
                <p style={{ color: "#999", textAlign: "center" }}>
                  ⏳ Checking limit...
                </p>
              )}

              {limit === 0 && (
                <p
                  style={{
                    color: "red",
                    marginTop: "10px",
                    textAlign: "center",
                  }}
                >
                  ⚠ Paper limit exceeded
                </p>
              )}
            </div>
          </div>

          {/* <div className="mb-3">
            <label className="fw-bold">Select Subject</label>
            <select
              className="form-control"
              onChange={(e) => setData(e.target.value)}
            >
              {tradedata.data.map((item) => (
                <option key={item.TRADE_ID} value={item.TRADE_ID}>
                  {item.TRADE_NAME}
                </option>
              ))}
            </select>
            <select
              className="form-select my-2"
              onChange={(e) => setnumofQue(parseInt(e.target.value))}
            >
              {[20, 25, 30, 50].map((n) => (
                <option key={n}>{n}</option>
              ))}
            </select>
          </div> */}
          <div className="mb-3">
            <label className="fw-bold">Select Subject</label>
            {tradedata?.data?.length > 0 ? (
              <>
                <select
                  className="form-control"
                  onChange={(e) => setData(e.target.value)}
                >
                  {tradedata.data.map((item) => (
                    <option key={item.TRADE_ID} value={item.TRADE_ID}>
                      {item.TRADE_NAME}
                    </option>
                  ))}
                </select>
                <select
                  className="form-select my-2"
                  onChange={(e) => setnumofQue(parseInt(e.target.value))}
                >
                  {[20, 25, 30, 50].map((n) => (
                    <option key={n}>{n}</option>
                  ))}
                </select>
              </>
            ) : (
              <div className="text-center my-3">
                <div className="spinner-border text-primary" />
                <p className="mt-2">Loading Subjects...</p>
              </div>
            )}
          </div>
          {paperMode === "random" && (
            <>
              <input
                className="form-control my-2"
                placeholder="Paper Title"
                onChange={(e) => settestName(e.target.value)}
              />

              {topics.length > 0 ? (
                topics.map((topic) => (
                  <div key={topic.TOPIC_UID} className="topic-row">
                    <input
                      type="checkbox"
                      onChange={() => handleTopicToggle(topic.TOPIC_UID)}
                    />
                    {topic.TOPIC_NAME}
                  </div>
                ))
              ) : (
                <div>
                  {[...Array(5)].map((_, i) => (
                    <div key={i} className="skeleton-topic"></div>
                  ))}
                </div>
              )}
              {paperLimitExceeded && (
                <button className="btn btn-warning mt-3" onClick={openRazorpay}>
                  💳 Buy Token
                </button>
                // <div>
                //   <h2>Buy Tokens</h2>
                //   <form ref={formRef}></form>
                // </div>
              )}
              <button
                className="btn btn-primary mt-3"
                onClick={submitRandomPaper}
              >
                🖨 Generate Random PDF
              </button>
            </>
          )}

          {paperMode === "manual" && (
            <>
              <div className="alert alert-info mt-3">
                Selected: <b>{selectedQuestions.length}</b> / {numofQue}
              </div>
              {topics.map((topic) => (
                <div className="card my-2" key={topic.TOPIC_UID}>
                  <div onClick={() => fetchQuestionsByTopic(topic.TOPIC_UID)}>
                    {topic.TOPIC_NAME}
                  </div>

                  {activeTopic === topic.TOPIC_UID &&
                    topicQuestions[topic.TOPIC_UID]?.map((q) => (
                      <div key={q.QUE_UID}>
                        <input
                          type="checkbox"
                          checked={selectedQuestions.includes(q.QUE_UID)}
                          onChange={() => handleQuestionSelect(q.QUE_UID)}
                        />
                        {q.QUESTION}
                      </div>
                    ))}
                </div>
              ))}
              {paperLimitExceeded && (
                <button className="btn btn-warning mt-3" onClick={openRazorpay}>
                  💳 Buy Token
                </button>
              )}
              <button
                className="btn btn-success mt-3"
                onClick={submitManualPaper}
              >
                🖨 Generate Manual PDF
              </button>
            </>
          )}
        </div>
      )}
    </>
  );
}
